import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Field, reduxForm } from 'redux-form';
import { Button } from 'fitbeat.react-native-components';
import { Text, View, StyleSheet } from 'react-native';
import { getNextBookingStep } from '../actions';
import { TextInput, FormError } from '../../ui';
import {
    i18n, getMomentFormat, isRequired, isNumber, minWeight,
    maxWeight,
    sanitizeHeartRateMonitorId,
} from '../../utils';
import { styles as sharedStyles } from './Styles';
import { BookingFlowFooter } from '../components';
import { ProcessTypes } from 'fitbeat.gym-core';
import Theme from '../../theme';
import { focusOnInput } from '../../utils/FocusOnInput';

class Metrics extends Component {
    static getSubtitle = ({ day, gymTimezone }) => (
        <View style={sharedStyles.subtitleContainer}>
            <Text style={sharedStyles.subtitle}>
                {getMomentFormat(day.date, 'dddd', gymTimezone)}
            </Text>
            <View style={sharedStyles.verticalSeparator} />
            <Text style={sharedStyles.subtitle}>
                {getMomentFormat(day.date, 'DD MMM', gymTimezone)}
            </Text>
        </View>
    );

    state = {
        isLoading: false,
        error: null,
    }

    onSubmit = async (values) => {
        const {
            userProfile,
            userProfileService,
            getNextBookingStep,
        } = this.props;
        try {
            this.setState({ error: null, isLoading: true });
            userProfile.weight = values.weight;
            userProfile.heartRateMonitorIdentifier = sanitizeHeartRateMonitorId(values.heartRateMonitorIdentifier);
            const updateUserProfile = await userProfileService.updateUserProfile(userProfile);
            getNextBookingStep(updateUserProfile, ProcessTypes.Start);
        } catch (error) {
            this.setState({ error });
        } finally {
            this.setState({ isLoading: false });
        }
    }

    render() {
        const { t, handleSubmit } = this.props;
        const { isLoading, error } = this.state;

        return (
            <View style={sharedStyles.container}>
                <Field
                    forwardRef
                    name="weight"
                    component={TextInput}
                    autoCapitalize="none"
                    placeholder={t('formFields:weight')}
                    keyboardType="numeric"
                    returnKeyType="next"
                    inputContainerStyle={styles.weightInputContainerStyle}
                    onSubmitEditing={() => focusOnInput(this.heartRateMonitorIdentifierInput)}
                    validate={[isRequired, isNumber, minWeight, maxWeight]}
                    ref={(ref) => { this.weightInput = ref; }}
                />
                <Text style={styles.infoText}>{t('bookings:weightNotice')}</Text>
                <Field
                    forwardRef
                    name="heartRateMonitorIdentifier"
                    component={TextInput}
                    autoCapitalize="none"
                    placeholder={t('formFields:heartRateBeltNumber')}
                    keyboardType="numeric"
                    validate={isNumber}
                    onSubmitEditing={handleSubmit(this.onSubmit)}
                    returnKeyType="done"
                    isRequired={false}
                    ref={(ref) => { this.heartRateMonitorIdentifierInput = ref; }}
                />
                <Text style={styles.infoText}>{t('bookings:hrmNotice')}</Text>
                <View style={styles.footer}>
                    <BookingFlowFooter>
                        <FormError error={error} />

                        <Button
                            fontColor={Theme.WHITE}
                            isLoading={isLoading}
                            title={t('bookings:next')}
                            onPress={handleSubmit(this.onSubmit)}
                        />
                    </BookingFlowFooter>
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    footer: {
        flex: 1,
        justifyContent: 'flex-end',
    },
    weightInputContainerStyle: {
        marginTop: 6,
    }, 
    infoText: {
        fontSize: 12,
        color: Theme.GREY_DARK_MEDIUM,
        fontFamily: Theme.CustomNormalItalic,
        marginTop: -5,
        paddingLeft: 1,
        paddingBottom: 10,
    },
});

const mapDispatchToProps = (dispatch) => {
    return {
        getNextBookingStep: (userProfile, processType) => dispatch(getNextBookingStep(userProfile, processType)),
    };
};

Metrics = translate(['auth', 'formFields', 'bookings'], { wait: true })(Metrics);
Metrics = connect(null, mapDispatchToProps)(Metrics);
Metrics = reduxForm({ form: 'MetricsForm' })(Metrics);
export default Metrics;
